import { DailyNormsData } from '@/types/settings.types';
import { DayBalanceView } from '../day-balance/dayBalance';

/** Виконання денних цілей клієнта, % (ціле); `null` - нема факту або цілі. */
export interface DayNormProgress {
  carbs: number | null;
  fat: number | null;
  protein: number | null;
  kcal: number | null;
  burned: number | null;
}

const percent = (fact: number | null, goal: number | string | null | undefined): number | null => {
  const target = Number(goal);
  if (fact === null || !Number.isFinite(target) || target <= 0) return null;
  return Math.round((fact / target) * 100);
};

/**
 * Факт дня відносно денних цілей клієнта. Цілі - поточні: історії цілей у системі нема, тож минулі дні теж
 * порівнюються з сьогоднішніми цілями. null - нема цілей або жодного показника не порахувати.
 */
export function getDayNormProgress(balance: DayBalanceView | null, goals: DailyNormsData | null): DayNormProgress | null {
  if (!balance || !goals) return null;
  const progress: DayNormProgress = {
    carbs: percent(balance.carbs, goals.carbsG),
    fat: percent(balance.fat, goals.fatG),
    protein: percent(balance.protein, goals.proteinG),
    kcal: percent(balance.kcal, goals.caloriesIntake),
    burned: percent(balance.burned, goals.caloriesBurned),
  };
  return Object.values(progress).some(value => value !== null) ? progress : null;
}
